import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import LoginDialog from '../../informationWindow/loginDialog'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import { followUser, unfollowUser } from '../../../store/member/memberSlice'
import { switchIsNecessaryToShowBackButtonOnTrue } from '../../../store/common/commonSlice'
import { checkIsFollowingUser } from '../../../utils/isFollowingUser'
import { Profile } from '../../../store/commonTypes'
import { RootState } from '../../../store/rootReducer'
import { MemberState } from '../../../store/member/memberTypings'
import paths from '../../../paths'
import s from './avatarBlock.module.sass'

interface Props {
    user: Profile
    self: boolean
}

const AvatarBlock: React.FunctionComponent<Props> = ({ user, self }: Props) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const [t] = useTranslation()

    const member = useSelector<RootState, MemberState>((state) => state.member)

    const [followed, setFollowed] = useState(false)
    const [loginDialog, setLoginDialog] = useState(false)

    const isNecessaryToShowLoginDialog = () => !member.loggedIn || member.user.active === 0

    const handleSendMessage = () => {
        if (isNecessaryToShowLoginDialog()) {
            setLoginDialog(true)
        } else {
            history.push({
                pathname: createLocalizedPath(paths.memberMessagePmConversations.path),
                search: `?pm=` + user.id
            })
        }
    }

    const handleFollowUnfollowUser = () => {
        if (isNecessaryToShowLoginDialog()) {
            setLoginDialog(true)
        } else {
            followed ? dispatch(unfollowUser({ id: user.id })) : dispatch(followUser({ id: user.id }))
            setFollowed(!followed)
        }
    }

    const handleSendGift = () => {
        if (isNecessaryToShowLoginDialog()) {
            setLoginDialog(true)
        } else {
            history.push({
                pathname: createLocalizedPath(paths.payment.path),
                search: `?gift=${user.nick}`
            })
            dispatch(switchIsNecessaryToShowBackButtonOnTrue())
        }
    }

    useEffect(() => {
        if (member.loggedIn) {
            const fetchIsFollowing = async () => {
                setFollowed(await checkIsFollowingUser(user.id))
            }
            fetchIsFollowing()
        }
    }, [followed])

    return (
        <>
            <div className={s['avatarBlock']}>
                {user.avatar_certified_photo_url ? (
                    <Link to={user.avatar_certified_page_url}>
                        <img src={user.avatar_certified_photo_url} alt="" />
                        <img className={s['chosenAvatar']} src={user.avatar_url} alt="" />
                    </Link>
                ) : (
                    <img src={user.avatar_url} alt="" />
                )}

                {user.certified == 1 ? (
                    <Link to={user.avatar_certified_page_url} className={s['certified']}>
                        {t('Bobeuse certifiée')}
                    </Link>
                ) : (
                    <></>
                )}
                {self ? (
                    <></>
                ) : (
                    <div className={followed ? `${s['userOptions']} ${s['followed']}` : s['userOptions']}>
                        <div onClick={() => handleSendMessage()}>{t('Message')}</div>
                        <div onClick={() => handleFollowUnfollowUser()}>{followed ? t('unfollow') : t('follow')}</div>
                        <div onClick={() => handleSendGift()}>{t('Give')}</div>
                    </div>
                )}
            </div>
            <LoginDialog loginDialog={loginDialog} setLoginDialog={setLoginDialog} />
        </>
    )
}

export default AvatarBlock
